import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { User } from '../../models/core.models';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UserProfileComponent {
  @Input() user: User;

  constructor() {}

  ngOnInit() {
    // console.log(this.user);
  }

  loadUser() {
    // this.userService.loadUserProfile(this.userId).subscribe(
    //   user => this.user = user
    // )
  }
}
